import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CategoriesService } from 'src/app/shared/services/wordpress-api/categories.service';
import { PostsService } from 'src/app/shared/services/wordpress-api/posts.service';
import { SeoService } from 'src/app/shared/services/angular-service/seo.service';

@Component({
  selector: 'app-blog-details-layout',
  templateUrl: './blog-details-layout.component.html',
  styleUrls: ['./blog-details-layout.component.scss'],
})
export class BlogDetailsLayoutComponent implements OnInit {
  @Input() data: any;

  constructor() {}

  ngOnInit(): void {
    // console.log(this.data)
  }
}
